import { ReactNode } from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import CheckBox, { CheckBoxType } from '@/components/view/atoms/checkbox/CheckBox'

export const FormSelectorValue = {
  BOOLEAN: 'boolean'
} as const

export type FormSelectorValue = (typeof FormSelectorValue)[keyof typeof FormSelectorValue]

interface Props<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  type?: CheckBoxType
  label?: ReactNode
  incomplete?: boolean
  optionToggle?: boolean
  forDisclosure?: boolean
  forRow?: boolean
  labelNode?: ReactNode
  onValue?: any
  offValue?: any
  nowrap?: boolean
  disabled?: boolean
  toggleText?: { left: string; right: string }
}

const FormCheckBox = <T extends FieldValues>({
  control,
  name,
  type = CheckBoxType.CHECK,
  label,
  incomplete = false,
  optionToggle = false,
  forDisclosure,
  forRow,
  labelNode,
  onValue = true,
  offValue = false,
  nowrap = false,
  disabled = false,
  toggleText
}: Props<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CheckBox
          type={type}
          label={label}
          name={field.name}
          checked={field.value == onValue}
          disabled={disabled}
          incomplete={incomplete}
          optionToggle={optionToggle}
          forDisclosure={forDisclosure}
          forRow={forRow}
          labelNode={labelNode}
          onChange={(checked) => field.onChange(checked ? onValue : offValue)}
          nowrap={nowrap}
          block
          toggleText={toggleText}
        />
      )}
    />
  )
}

export default FormCheckBox
